<template>
  <div>
    <div class="kl-form">
      <div class="kl-form__section">
        <label class='typo__body--reg'>{{Kadenze.I18n.t('learning_module.add_activity.type')}}</label>
        <div class="kl-form__row">
          <div class="kl-form__col">
            <selectpicker
               v-bind:title="Kadenze.I18n.t('learning_module.add_activity.select_type')"
               :options='typeOptions'
               optionsValue='value'
               optionsText='name'
               v-model='type' /> </div>
        </div>
      </div>

      <div class="kl-form__section" v-if='type'>
        <label class='typo__body--reg'>{{Kadenze.I18n.t('learning_module.add_activity.activity')}}</label>
        <div class="kl-form__row">
          <div class="kl-form__col">
            <selectpicker
              :searchable='true'
              :options='activitySet'
              optionsText='title'
              optionsValue='id'
              v-model='learning_modulable_id' />
          </div>
        </div>
      </div>
    </div>

    <div class="kl-form__section">
      <div class="kl-form__row">
        <div class="kl-form__col">
          <div class='typo__subhead--reg'>{{Kadenze.I18n.t('learning_module.add_activity.options')}}</div>
        </div>
      </div>

      <div class="kl-form__row">
        <div class="kl-form__col">
          <checkbox v-bind:label="Kadenze.I18n.t('learning_module.add_activity.completion_required')" v-model='required'></checkbox>
        </div>
      </div>
    </div>

    <div v-if='required && type' class="kl-form__section">
      <div class='typo__body--reg'>{{Kadenze.I18n.t('learning_module.completed_on')}}</div>
      <div class="kl-form__row">
        <div class="kl-form__col">
          <selectpicker :options='criteriaOptions[type]'
                        v-model='criteria' />
        </div>
      </div>
    </div>

    <div class="kl-form__row kl-form__row--right">
      <div class="kl-form__col">
        <a class="inline-block-link--del typo__body--reg"
          href="javascript:;"
          @click='$emit("close")'>{{Kadenze.I18n.t('dict.cancel')}}</a>
      </div>
      <div class="kl-form__col">
        <a class="inline-block-link typo__body--reg"
          href="javascript:;"
          @click='save'>{{Kadenze.I18n.t('dict.save')}}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modulables: {
      type: Object,
      required: true
    },
    currentActivity: {
      default: false
    }
  },
  data() {
    return {
      typeOptions: [
        {
          name: 'Session',
          value: 'lecture'
        },
        {
          name: Kadenze.I18n.n('Coursework'),
          value: 'coursework'
        },
        {
          name: 'Resource',
          value: 'resource'
        }
      ],
      criteriaOptions: {
        lecture: [
          Kadenze.I18n.t('learning_module.criteria_options.viewed'),
          Kadenze.I18n.t('learning_module.criteria_options.scrolled')
        ],
        coursework: [
          Kadenze.I18n.t('learning_module.criteria_options.completed'),
          Kadenze.I18n.t('learning_module.criteria_options.graded')
        ],
        resource: [
          I18n.t('dict.activity'),
          Kadenze.I18n.t('learning_module.criteria_options.downloaded')
        ]
      },
      required: false,
      // TODO : this titleized version should be computed and learning_module_type
      // should be source of truth in data
      type: null,
      learning_modulable_id: null,
      criteria: null,
      id: null
    };
  },
  mounted() {
    if ( this.currentActivity ) {
      this.bindData(this.currentActivity)
    }
  },
  computed: {
    learning_modulable_type() {
      return s.capitalize(this.type);
    },
    activitySet() {
      return this.modulables[this.type];
    },
    title() {
      return _.find(this.activitySet, i => i.id == this.learning_modulable_id).title;
    }
  },
  watch: {
    type() {
      this.criteria = this.criteriaOptions[this.type][0]
      this.learning_modulable_id = this.activitySet[0].id
    },
  },
  methods: {
    bindData(data) {
      this.type = data.learning_modulable_type.toLowerCase();
      this.id = data.id;
      this.$nextTick(() => {
        this.learning_modulable_id = data.learning_modulable_id;
        this.required = data.required;
        this.criteria = data.criteria.type;
      })
    },
    save() {
      this.$emit('save', {
        learning_modulable_type: this.learning_modulable_type,
        learning_modulable_id: this.learning_modulable_id,
        id: this.id,
        required: this.required,
        criteria: { type: this.criteria, value: true },
      });
      this.$emit('close');
    }
  }
}
</script>
